import { render, staticRenderFns } from "./WechatBindForm.vue?vue&type=template&id=175b7c52&scoped=true&"
import script from "./WechatBindForm.vue?vue&type=script&lang=js&"
export * from "./WechatBindForm.vue?vue&type=script&lang=js&"
import style0 from "./WechatBindForm.vue?vue&type=style&index=0&id=175b7c52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b7c52",
  null
  
)

export default component.exports